var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3492 8.81566C22.3492 8.3934 22.1814 7.98843 21.8829 7.68984C21.5844 7.39127 21.1793 7.22352 20.7571 7.22352H17.9708L15.5826 3.24316H8.41797L6.02976 7.22352H3.24351C2.82124 7.22352 2.41628 7.39127 2.11769 7.68984C1.81911 7.98843 1.65137 8.3934 1.65137 8.81566V19.1646C1.65137 19.5868 1.81911 19.9919 2.11769 20.2904C2.41628 20.5889 2.82124 20.7567 3.24351 20.7567H20.7571C21.1793 20.7567 21.5844 20.5889 21.8829 20.2904C22.1814 19.9919 22.3492 19.5868 22.3492 19.1646V8.81566Z",
    stroke: "#52509A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 17.2243C14.1982 17.2243 15.9802 15.4423 15.9802 13.244C15.9802 11.0457 14.1982 9.26367 11.9999 9.26367C9.8016 9.26367 8.01953 11.0457 8.01953 13.244C8.01953 15.4423 9.8016 17.2243 11.9999 17.2243Z",
    stroke: "#52509A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.9f3cac3a5990f2b891e2df072965618f.svg";
export { ForwardRef as ReactComponent };